/** Свои покупки оператора за выбранную дату (04.09, владелец) — компактный
 *  список под строкой действий дашборда. GET /api/op-purchases?from=d&to=d:
 *  оператору сервер отдаёт только его строки; operator_id= — чтобы мультироль
 *  с assignments:write тоже видела здесь СВОИ (плюс фильтр на клиенте).
 *  Статус: ожидает (text-2) / подтверждено (lime) / отклонено (red + причина).
 *  Pending можно удалить — инлайн-подтверждение «удалить? да/нет» (native
 *  confirm запрещён рэтчетом, DECISIONS-MASTER A3). 04.09 (ревью): после
 *  ошибки DELETE (например 404 — ОО уже подтвердил/удалил) список
 *  перечитываем, чтобы не висела призрачная строка; текст ошибки — в тост. */
import { useCallback, useEffect, useState } from "react";
import { api } from "../../api/client";
import { ApiException } from "../../api/types";
import { fmtDateApi } from "../../utils/date";
import css from "./dashActions.module.css";

export interface OpPurchase {
  id: number; operator_id: string; date: string; amount: number; item: string;
  consumable_id: string | null; comment: string | null;
  status: "pending" | "approved" | "rejected"; reject_reason: string | null; created_at: string;
  photos: { id: number; name: string | null }[];
}

export function MyPurchases({ date, operatorId, tick, onToast }: {
  date: Date; operatorId: string; tick: number; onToast: (msg: string, err?: boolean) => void;
}) {
  const [rows, setRows] = useState<OpPurchase[]>([]);
  const [arm, setArm] = useState<number | null>(null);
  const [busy, setBusy] = useState<number | null>(null);
  const [n, setN] = useState(0);
  const reload = useCallback(() => setN((x) => x + 1), []);

  useEffect(() => {
    let alive = true;
    const d = fmtDateApi(date);
    const q = operatorId ? `&operator_id=${encodeURIComponent(operatorId)}` : "";
    api<{ results?: OpPurchase[] }>(`/api/op-purchases?from=${d}&to=${d}${q}`)
      .then((r) => { if (alive) setRows((r.results ?? []).filter((p) => !operatorId || p.operator_id === operatorId)); })
      .catch(() => { if (alive) setRows([]); });
    return () => { alive = false; };
  }, [date, operatorId, tick, n]);

  const del = async (id: number) => {
    setBusy(id);
    try { await api(`/api/op-purchases/${id}`, { method: "DELETE" }); onToast("Покупка удалена"); }
    catch (e) { onToast(e instanceof ApiException && e.body?.error ? `Не удалось удалить: ${e.body.error}` : "Не удалось удалить покупку", true); }
    finally { setBusy(null); setArm(null); reload(); }
  };

  if (!rows.length) return null;
  return (
    <div className={css.pur}>
      {rows.map((p) => (
        <div key={p.id} className={`${css.purRow} ${p.status === "rejected" ? css.purRej : ""}`}>
          <span className={css.purItem}>🧾 {p.item}{p.photos?.length ? <span className={css.purPh}> · 📷{p.photos.length}</span> : null}</span>
          <span className={css.purSum}>₽{Number(p.amount).toLocaleString("ru")}</span>
          {p.status === "pending" ? (arm === p.id ? (
            <span className={css.purAsk}>удалить?
              <button type="button" className={css.purYes} disabled={busy === p.id} onClick={() => void del(p.id)}>{busy === p.id ? "…" : "да"}</button>
              <button type="button" className={css.purNo} onClick={() => setArm(null)}>нет</button>
            </span>
          ) : (
            <>
              <span className={`${css.purSt} ${css.stWait}`}>ожидает</span>
              <button type="button" className={css.purDel} title="Удалить покупку" aria-label="Удалить покупку" onClick={() => setArm(p.id)}>✕</button>
            </>
          )) : p.status === "approved" ? (
            <span className={`${css.purSt} ${css.stOk}`}>✓ подтверждено</span>
          ) : (
            <span className={`${css.purSt} ${css.stRej}`}>✕ отклонено{p.reject_reason ? ` (${p.reject_reason})` : ""}</span>
          )}
        </div>
      ))}
    </div>
  );
}
